<template>
  <button
    class="vk-btn-component"
    @click="vkBtnClick"
    :class="[{'vk-btn_plain':plain , 'vk-btn_disabled':disabled}, sizeClass]"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    sizeClass() {
      return `vk-btn-size_${this.size}`
    }
  },
  methods: {
    vkBtnClick() {
      if (this.disabled || this.loading) {
        return
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="less" scoped>
.vk-btn-component {
  box-sizing: border-box;
  height: 30px;
  line-height: 28px;
  border-radius: 3px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  padding: 0 20px;
  background-color: #f85415;
  border: 1px solid #f85415;
  font-size: inherit;
  transition: opacity 0.3s;
  &:hover {
    opacity: 0.85;
  }
  &.vk-btn_plain {
    background-color: transparent;
    color: #f85415;
  }
  &.vk-btn_disabled {
    cursor: not-allowed;
    background-color: #b9b9b9;
    border: 1px solid #b9b9b9;
    color: #fff;
    &:hover{
      opacity: 1;
    }
  }
  &.vk-btn-size_large {
    height: 35px;
    line-height: 32px;
  }
}
.vk-btn-component + .vk-btn-component {
  margin: 5px;
}
</style>
